import type { EnrollOverridesMap } from '@/types/api'

/**
 * Rimuove i contatti senza alcun override di step; undefined se non resta
 * nulla, così il payload di enroll omette del tutto la chiave `overrides`.
 */
export function pruneEmptyOverrides(map: EnrollOverridesMap): EnrollOverridesMap | undefined {
  const pruned = Object.fromEntries(
    Object.entries(map).filter(([, steps]) => Object.keys(steps).length > 0),
  )
  return Object.keys(pruned).length > 0 ? pruned : undefined
}

/** Contatti che l'iscrizione invierebbe con almeno un override. */
export function countCustomizedContacts(map: EnrollOverridesMap): number {
  return Object.keys(pruneEmptyOverrides(map) ?? {}).length
}
